import React, { memo } from "react";
import PropTypes from "prop-types";
import { AspectRatio, Box, Image } from "@chakra-ui/react";
import * as PostMediaTypes from "./PostMediaTypes.constants";

const PostMediaPreview = ({ item }) => {
  const { type, url, thumbUrl } = item;

  return (
    <AspectRatio ratio={4 / 3}>
      <Box>
        {type === PostMediaTypes.VIDEO ? (
          <Box
            as="video"
            objectFit="contain"
            width="100%"
            height="100%"
            src={url}
            controls
            poster={thumbUrl}
          />
        ) : (
          <Image objectFit="contain" width="100%" height="100%" src={url} />
        )}
      </Box>
    </AspectRatio>
  );
};

PostMediaPreview.propTypes = {
  item: PropTypes.shape({
    type: PropTypes.oneOf([PostMediaTypes.PHOTO, PostMediaTypes.VIDEO])
      .isRequired,
    url: PropTypes.string.isRequired,
  }).isRequired,
};

PostMediaPreview.defaultProps = {};

export default memo(PostMediaPreview);
